import { useState } from 'react';

export function useFileHubMeta(activeWorkspace) {
  const [metaOpen, setMetaOpen] = useState(false);
  const [metaProcessMode, setMetaProcessMode] = useState(() => {
    const pid = String(activeWorkspace?.ancestry?.primary_process_id || '').trim();
    const note = String(activeWorkspace?.ancestry?.pre_processual_note || '').trim();
    if (pid) return 'npu';
    if (note) return 'alias';
    return 'alias';
  });
  const [metaNpu, setMetaNpu] = useState(() => String(activeWorkspace?.ancestry?.primary_process_id || '').trim());
  const [metaAlias, setMetaAlias] = useState(() => String(activeWorkspace?.ancestry?.pre_processual_note || '').trim());
  const [metaJurisdiction, setMetaJurisdiction] = useState(() => {
    const raw = activeWorkspace?.ancestry?.jurisdiction_branch;
    if (Array.isArray(raw)) return raw.map((v) => String(v || '').trim()).filter(Boolean);
    const single = String(raw || '').trim();
    return single ? [single] : [];
  });
  const [metaJurisdictionOpen, setMetaJurisdictionOpen] = useState(false);
  const [metaLiminar, setMetaLiminar] = useState(() => String(activeWorkspace?.metadata?.liminar || '').trim() || 'NAO');
  const [metaLiminarTipo, setMetaLiminarTipo] = useState(() => String(activeWorkspace?.metadata?.liminar_tipo || '').trim());
  const [metaObjeto, setMetaObjeto] = useState(() => String(activeWorkspace?.metadata?.objeto || '').trim());
  const [metaPartesContrarias, setMetaPartesContrarias] = useState(() => {
    const raw = activeWorkspace?.metadata?.parte_contraria;
    if (!raw) return [];
    if (typeof raw === 'string') {
      try { return JSON.parse(raw); } catch { return [raw]; }
    }
    if (Array.isArray(raw)) return raw;
    return [];
  });
  const [metaResumo, setMetaResumo] = useState(() => String(activeWorkspace?.metadata?.resumo || '').trim());
  const [metaUrgencia, setMetaUrgencia] = useState(() => String(activeWorkspace?.metadata?.urgencia || '').trim() || 'MEDIA');
  const [metaGratuita, setMetaGratuita] = useState(() => String(activeWorkspace?.metadata?.justica_gratuita || '').trim() || 'NAO');
  const [metaGratuitaJust, setMetaGratuitaJust] = useState(() => String(activeWorkspace?.metadata?.justica_gratuita_justificativa || '').trim());

  return {
    metaOpen, setMetaOpen,
    metaProcessMode, setMetaProcessMode,
    metaNpu, setMetaNpu,
    metaAlias, setMetaAlias,
    metaJurisdiction, setMetaJurisdiction,
    metaJurisdictionOpen, setMetaJurisdictionOpen,
    metaLiminar, setMetaLiminar,
    metaLiminarTipo, setMetaLiminarTipo,
    metaObjeto, setMetaObjeto,
    metaPartesContrarias, setMetaPartesContrarias,
    metaResumo, setMetaResumo,
    metaUrgencia, setMetaUrgencia,
    metaGratuita, setMetaGratuita,
    metaGratuitaJust, setMetaGratuitaJust,
  };
}
